/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string DismissRequestDialog shows by default. Each string below is new copy, marked
 * CANDIDATE. The caller can replace any of them through the `copy` prop.
 */

export type DismissRequestDialogCopy = {
  /** The title, and the name of the dialog for a screen reader. */
  title: (providerName: string) => string;
  /** What declining means for the customer. The first of three consequences. */
  noService: string;
  /** The second consequence. */
  obligations: string;
  /** The third consequence. It is information, and has its own icon. */
  newInvite: string;
  /** The button that closes the request for good. */
  decline: string;
  /** The safe button that leaves the request open. */
  goBack: string;
};

export const DISMISS_REQUEST_DIALOG_COPY: DismissRequestDialogCopy = {
  // CANDIDATE COPY, not approved (verifime-adr#617)
  title: (providerName) => `Decline the request from ${providerName}?`,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  noService: 'You will not get the service from this provider.',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  obligations:
    'Anti-money laundering rules and other obligations may stop the provider working with you.',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  newInvite: 'The provider may contact you. To ask again, they must send a new invite.',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  decline: 'Decline',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  goBack: 'Go back',
};

/** Overrides for the default copy. Any string may be left out. A string set to `undefined` counts as left out. */
export type DismissRequestDialogCopyOverrides = Partial<DismissRequestDialogCopy>;

/** The default copy with the caller's overrides laid over it, one string at a time. */
export function resolveDismissRequestDialogCopy(
  overrides: DismissRequestDialogCopyOverrides = {},
): DismissRequestDialogCopy {
  const given = Object.fromEntries(
    Object.entries(overrides).filter(([, text]) => text !== undefined),
  );
  return { ...DISMISS_REQUEST_DIALOG_COPY, ...given };
}
